exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-contact-form-jsx": () => import("./../../../src/pages/contact-form.jsx" /* webpackChunkName: "component---src-pages-contact-form-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-typ-jsx": () => import("./../../../src/pages/typ.jsx" /* webpackChunkName: "component---src-pages-typ-jsx" */)
}

